"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
// Import necessary dependencies and components
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const native_base_1 = require("native-base");
const react_redux_1 = require("react-redux");
const constants_1 = require("../../common/constants");
const AppText_1 = require("../../component/AppText");
const colors_1 = require("../../common/colors");
const fontSettings_1 = require("../../slices/fontSettings");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
const BigButton_1 = __importDefault(require("../../component/GradientButton/BigButton"));
const FontSettingsModal = ({ isOpen, onClose }) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const selectedFontId = (0, react_redux_1.useSelector)((state) => state.fontSettings.selectedFontId);
    const [tempSelectedFontId, setTempSelectedFontId] = react_1.default.useState(selectedFontId);
    const updateFontFamily = (fontId) => {
        if (typeof document !== 'undefined') {
            const selectedFont = constants_1.AVAILABLE_FONTS.find(font => font.id === fontId);
            const fontFamily = selectedFont?.fontFamily;
            if (fontFamily) {
                // Set the CSS variable to the selected font family
                document.documentElement.style.setProperty('--app-font-family', fontFamily);
            }
        }
    };
    const handleSetFont = () => {
        // Dispatch the action to set the selected font
        dispatch((0, fontSettings_1.setSelectedFont)(tempSelectedFontId));
        // Call the function to update the font family
        updateFontFamily(tempSelectedFontId);
        // Close the modal
        onClose();
    };
    return ((0, jsx_runtime_1.jsx)(react_native_1.Modal, { visible: isOpen, transparent: true, animationType: "slide", children: (0, jsx_runtime_1.jsx)(native_base_1.NativeBaseProvider, { children: (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.modalOverlay, children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.modalContent, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.header, children: [(0, jsx_runtime_1.jsx)(AppText_1.AppText, { color: colors_1.Colors.white, fontSize: 20, fontWeight: "500", children: "Select Font" }), (0, jsx_runtime_1.jsx)(react_native_1.TouchableOpacity, { onPress: onClose, style: styles.closeButton, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faClose, color: colors_1.Colors.white, size: 18 }) })] }), (0, jsx_runtime_1.jsx)(native_base_1.VStack, { space: 4, children: (0, jsx_runtime_1.jsx)(native_base_1.Radio.Group, { name: "fontGroup", value: tempSelectedFontId, onChange: (value) => setTempSelectedFontId(value), children: constants_1.AVAILABLE_FONTS.map((font) => ((0, jsx_runtime_1.jsx)(native_base_1.Radio, { value: font.id, my: 2, _text: {
                                        color: colors_1.Colors.white,
                                        fontFamily: font.fontFamily
                                    }, _icon: {
                                        color: colors_1.Colors.PRIMARY_300,
                                        size: 3,
                                    }, children: font.id === 'geist-sans' || font.id === 'inter' ? `${font.name} - Welcome to Summaraizer` : font.id === 'opendyslexic' ? `${font.name} - Welc...` : `${font.name} - Welcome to Summai...` }, font.id))) }) }), (0, jsx_runtime_1.jsx)(BigButton_1.default, { onPress: handleSetFont, style: styles.setFontButton, children: "Set Font" })] }) }) }) }));
};
// Define styles for the component
const styles = react_native_1.StyleSheet.create({
    modalOverlay: {
        flex: 1,
        backgroundColor: `${colors_1.Colors.DARK_700}CC`,
        justifyContent: 'center',
        alignItems: 'center',
    },
    modalContent: {
        backgroundColor: colors_1.Colors.DARK_600,
        padding: 20,
        borderRadius: 16,
        width: '90%',
        maxWidth: 384,
    },
    header: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 20,
    },
    closeButton: {
        padding: 5,
    },
    setFontButton: {
        marginTop: 20,
        font: colors_1.Colors.DARK_700,
        backgroundColor: colors_1.Colors.PRIMARY_300,
    },
});
// Export the component
exports.default = FontSettingsModal;
